import React, { ReactNode } from "react";

import { IconButton, Typography } from "@mui/material";
import { styled, SxProps } from "@mui/system";

import infoCircle from "../assets/icons/information_circle.svg";
import warningCircle from "../assets/icons/warning.svg";
import { Theme } from "@emotion/react";
import { Close } from "@mui/icons-material";

const InfoContainer = styled("div")<{ type: "info" | "warning" }>(
  ({ theme, type }) => ({
    display: "flex",

    alignItems: "center",

    gap: "4px",
    padding: "8px",

    height: "60px",
    width: "100%",

    color: theme.palette.info.main,
    backgroundColor: type === "warning" ? theme.palette.secondary.light : theme.palette.info[100],

    textAlign: "center",

    fontFamily: "ABBvoice",
    fontSize: 14,
    fontStyle: "normal",
    fontWeight: 400,

    marginTop: "24px",
  })
);

interface TextContainerProps {
  text: string | ReactNode;
  type: "info" | "warning";
  sx?: SxProps<Theme>;
  close?: () => void;
}

const TextContainer: React.FC<TextContainerProps> = ({ text, type, sx, close }) => {
  return (
    <InfoContainer type={type} sx={{...sx, position: "relative"}} >
      {type === "info" && <img style={{stroke: 'red'}} alt="Information Circle" src={infoCircle} />}
      {type === "warning" && <img alt="Information Circle" src={warningCircle} />}
      <Typography
        sx={(theme) => ({
          color:
            type === "info"
              ? theme.palette.info.main
              : theme.palette.secondary.main,
        })}
        variant="bodyMediumWeightRegular"
      >
        {text}
      </Typography>
      {close && (
        <IconButton sx={{ padding: 0, position: "absolute", right: 8, top: '50%', transform: 'translateY(-50%)' }} onClick={close} aria-label="Close">
          <Close />
        </IconButton>
      )}
    </InfoContainer>
  );
};

export default TextContainer;
